import {take, call, fork, put} from 'redux-saga/effects'
import {
  GET_LOADING_IMAGE,
  UPLOAD_IMAGE_REQUEST
} from 'actions/uploadImage/constants'
import {
  getImage,
  getLoadingImage
} from 'sagas/api/uploadImage'
import {setTemporaryImage} from 'actions/uploadImage'

import FormData from 'form-data'

export function * getLoadingImageFlow () {
  while (true) {
    yield take(GET_LOADING_IMAGE)
    yield call(getLoadingImage)
  }
}

export function * uploadImageFlow () {
  while (true) {
    let request = yield take(UPLOAD_IMAGE_REQUEST)
    $('#save-public-profile').prop('disabled', true)
    $('#save-public-profile').html('Loading...')
    $('.upload-img-spinner').removeClass('hide')
    $('.upload-img').addClass('hide')
    let file = request.payload.file.file
    let data = yield call(getImage, {filename: file.name})
    let formData = new FormData()
    formData.append('key', data.key)
    formData.append('acl', data.acl)
    formData.append('AWSAccessKeyId', data.aws_access_key_id)
    formData.append('success_action_status', data.success_action_status)
    formData.append('Content-Type', data.content_type)
    formData.append('Cache-Control', data.cache_control)
    formData.append('policy', data.policy)
    formData.append('signature', data.signature)
    formData.append('file', file)
    try {
      fetch(`${data.url}`, {
        method: 'POST',
        body: formData
      }).then(() => {
        $('#save-public-profile').prop('disabled', false)
        $('#save-public-profile').html('Save')
        $('.upload-img-spinner').addClass('hide')
        $('.upload-img').removeClass('hide')
      })
    } finally {
      yield put(setTemporaryImage(data.fullUrl))
    }
  }
}

export default function * uploadImageSaga () {
  yield fork(getLoadingImageFlow)
  yield fork(uploadImageFlow)
}



// WEBPACK FOOTER //
// ./app/sagas/uploadImage/index.js